import { createSlice } from '@reduxjs/toolkit';

// const loadFilters = () => {
// 	const storageValue = localStorage.getItem('instantSearch');
// 	const parsedJson = storageValue ? JSON.parse(storageValue) : { filters: {} };
// 	return parsedJson.filters ?? {};
// };

const loadFilters = () => {
	const storageValue = localStorage.getItem('instantSearch');
	const parsedJson = storageValue ? JSON.parse(storageValue) : { filters: {}, filterSchema: {} };

	if (parsedJson.version !== process.env.REACT_APP_FILTERS_VERSION) {
		return { filters: {}, filterSchema: {} };
	}

	return {
		filters: parsedJson.filters ?? {},
		filterSchema: parsedJson.filterSchema ?? {},
	};
};

const persistedState = loadFilters();

export const instantSearchSlice = createSlice({
	name: 'instantSearch',
	initialState: {
		...persistedState,
		searchText: '',
	},
	reducers: {
		setFilters: (state, action) => {
			const { slug, type, values } = action.payload;
			if (values && Array.isArray(values)) {
				const valuesArray = values.filter((i) => i);
				if (!state.filters[slug]) {
					state.filters[slug] = {};
				}
				state.filters[slug][type] = valuesArray;

				localStorage.setItem(
					'instantSearch',
					JSON.stringify({
						filters: state.filters,
						filterSchema: state.filterSchema,
						version: process.env.REACT_APP_FILTERS_VERSION,
					}),
				);
			}
		},

		setFilterSchema: (state, action) => {
			const { slug, type, value } = action.payload;

			if (!state.filterSchema[slug]) {
				state.filterSchema[slug] = {};
			}

			if (value === null || value === undefined || value === '') {
				delete state.filterSchema[slug][type];

				if (Object.keys(state.filterSchema[slug]).length === 0) {
					delete state.filterSchema[slug];
				}
			} else {
				state.filterSchema[slug][type] = value;
			}

			localStorage.setItem(
				'instantSearch',
				JSON.stringify({
					filters: state.filters,
					filterSchema: state.filterSchema,
					version: process.env.REACT_APP_FILTERS_VERSION,
				}),
			);
		},
		// Payload is { [type]: validValues[] }; drops invalid values from that type on every slug.
		pruneFilters: (state, action) => {
			let changed = false;
			Object.values(state.filters).forEach((slugFilters) => {
				Object.entries(action.payload).forEach(([type, validValues]) => {
					const values = slugFilters[type];
					if (!values) return;
					const validFilterValues = values.filter((v) => validValues.includes(v));
					if (validFilterValues.length !== values.length) {
						slugFilters[type] = validFilterValues;
						changed = true;
					}
				});
			});

			if (changed) {
				localStorage.setItem(
					'instantSearch',
					JSON.stringify({
						filters: state.filters,
						filterSchema: state.filterSchema,
						version: process.env.REACT_APP_FILTERS_VERSION,
					}),
				);
			}
		},
		setSearchText: (state, action) => {
			state.searchText = action.payload;
		},
		resetFilters: (state, action) => {
			const slug = action.payload;
			state.filterSchema[slug] = {};
			state.filters[slug] = {};

			localStorage.setItem(
				'instantSearch',
				JSON.stringify({
					filters: state.filters,
					filterSchema: state.filterSchema,
					version: process.env.REACT_APP_FILTERS_VERSION,
				}),
			);
		},
	},
});

export const { setFilters, setFilterSchema, pruneFilters, setSearchText, resetFilters } =
	instantSearchSlice.actions;
export default instantSearchSlice.reducer;
